import { computed } from 'vue';

export type Realm = {
  realm: string;
  code: string;
};

// Order requested by Olivia
export const defaultRealms: Realm[] = [
  {
    realm: 'Sweden (se)',
    code: 'se',
  },
  {
    realm: 'Finland (fi)',
    code: 'fi',
  },
  {
    realm: 'Germany (de)',
    code: 'de',
  },
  {
    realm: 'Norway (no)',
    code: 'no',
  },
  {
    realm: 'United Kingdom (uk)',
    code: 'uk',
  },
  {
    realm: 'France (fr)',
    code: 'fr',
  },
  {
    realm: 'North America (us)',
    code: 'us',
  },
  {
    realm: 'Netherlands (nl)',
    code: 'nl',
  },
];

export const useRealmLabel = () => {
  const realmLabel = computed(
    () => (realmCode: string) => defaultRealms.find((realm) => realm.code === realmCode)?.realm || realmCode,
  );

  return {
    realmLabel,
  };
};
